import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountToDo } from 'sharedTypes/accountChecklist';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-edit-account-to-do',
  templateUrl: './edit-account-to-do.component.html',
  styleUrls: ['./edit-account-to-do.component.scss'],
  standalone: false
})
export class EditAccountToDoComponent {
    constructor(
        public glo: GlobalService,
        public dialogRef: MatDialogRef<EditAccountToDoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { toDo: AccountToDo },
    ) {}

    ngOnInit(): void {}

    async save() {
        this.dialogRef.close(this.data.toDo);
    }

    resetToDo() {
        this.data.toDo.done = false;
        this.data.toDo.doneAt = '';
        this.data.toDo.doneById = '';
        this.data.toDo.doneByName = '';
    }
}
